import "select2";

App.SupplierProductTypeWeights = (function () {
  function switchSupplierUrl(select, supplierId) {
    if (!supplierId) return null;
    var base = select.getAttribute("data-switch-url") || window.location.pathname;
    var sep = base.indexOf("?") >= 0 ? "&" : "?";
    return base + sep + "supplier_id=" + encodeURIComponent(supplierId);
  }

  function initSupplierSelect(root) {
    var select = root.querySelector("#wt-supplier");
    if (!select) return;

    function navigateToSupplier(supplierId) {
      var url = switchSupplierUrl(select, supplierId);
      if (!url) return;
      window.location = url;
    }

    // Always keep a native fallback — select2 enhance is optional.
    select.addEventListener("change", function () {
      navigateToSupplier(select.value);
    });

    if (!window.jQuery || !jQuery.fn.select2) return;

    var $select = jQuery(select);
    if ($select.data("select2")) return;

    $select.select2({
      width: "100%",
      placeholder: select.getAttribute("data-placeholder") || "Type to find a supplier",
      allowClear: false
    });

    $select.on("select2:select", function (event) {
      var selected = event && event.params && event.params.data;
      navigateToSupplier(selected && selected.id ? selected.id : $select.val());
    });
  }

  function init() {
    var root = document.getElementById("wt-app");
    if (!root) return;

    initSupplierSelect(root);

    var form = root.querySelector("#wt-form");
    var tbody = root.querySelector("#wt-rows");
    var sticky = root.querySelector("#wt-sticky-save");
    var discardButton = root.querySelector("#wt-discard-button");
    var imageInput = root.querySelector("#wt-image-input");
    var removeImageInput = root.querySelector("#wt-remove-image");
    var photoModeInput = root.querySelector("#wt-photo-mode");
    var photoPanel = root.querySelector(".wt-photo");
    var addTypeToggle = root.querySelector("#wt-add-type-toggle");
    var addTypePopover = root.querySelector("#wt-add-type-popover");
    var createTypeToggle = root.querySelector("#wt-create-type-toggle");
    var createTypeForm = root.querySelector("#wt-create-type-form");
    var createTypeName = root.querySelector("#wt-create-type-name");
    var createTypeSubmit = root.querySelector("#wt-create-type-submit");
    var createTypeUrl = root.getAttribute("data-create-type-url");
    var addSizesToggle = root.querySelector("#wt-add-sizes-toggle");
    var addSizesPopover = root.querySelector("#wt-add-sizes-popover");
    var emptyState = root.querySelector("#wt-empty-state");
    var tableWrap = root.querySelector("#wt-table-wrap");
    var statusEl = root.querySelector("#wt-status");
    var pasteModal = root.querySelector("#wt-paste-modal");
    var pasteOpen = root.querySelector("#wt-paste-open");
    var pasteCancel = root.querySelector("#wt-paste-cancel");
    var pasteApply = root.querySelector("#wt-paste-apply");
    var pasteArea = root.querySelector("#wt-paste-weights");
    var pickManual = root.querySelector("#wt-pick-sizes-manually");
    var searchUrl = root.getAttribute("data-search-url");
    var supplierId = root.getAttribute("data-supplier-id");
    var families = parseJson(root.getAttribute("data-size-families"), []);
    var searchTimers = {};

    function parseJson(raw, fallback) {
      try {
        return JSON.parse(raw || "null") || fallback;
      } catch (e) {
        return fallback;
      }
    }

    function markDirty() {
      if (sticky) sticky.hidden = false;
      refreshStatus();
    }

    function markClean() {
      if (sticky) sticky.hidden = true;
    }

    function cssEscape(value) {
      if (window.CSS && CSS.escape) return CSS.escape(value);
      return String(value).replace(/"/g, '\\"');
    }

    function familyFor(size) {
      var i;
      for (i = 0; i < families.length; i += 1) {
        if (families[i].sizes.indexOf(size) !== -1) return families[i];
      }
      if (/\d*X?LT$/i.test(size)) return { key: "tall", label: "Tall" };
      if (/^\d+T$/i.test(size)) return { key: "toddler", label: "Toddler" };
      if (/^\d+\s*[x×]\s*\d+$/i.test(size)) return { key: "print", label: "Print" };
      if (/^Youth/i.test(size) || (/^\d{1,2}$/.test(size) && parseInt(size, 10) >= 4 && parseInt(size, 10) <= 18)) {
        return { key: "youth", label: "Youth" };
      }
      return { key: "other", label: "Other" };
    }

    function familyOrder() {
      return families.map(function (family) { return family.key; }).concat(["other"]);
    }

    function currentPhotoFrame() {
      if (!photoPanel) return null;
      var mode = photoPanel.getAttribute("data-photo-mode") || "none";
      return photoPanel.querySelector('.wt-photo-frame[data-frame="' + mode + '"]');
    }

    function setPhotoMode(mode) {
      if (photoPanel) photoPanel.setAttribute("data-photo-mode", mode);
      if (photoModeInput) photoModeInput.value = mode;
      root.querySelectorAll('[data-segment="photo-mode"] button').forEach(function (button) {
        button.classList.toggle("is-active", button.getAttribute("data-value") === mode);
      });
      root.querySelectorAll(".wt-photo-state").forEach(function (el) {
        el.style.display = el.getAttribute("data-state") === mode ? "" : "none";
      });
    }

    function syncEmptyVisibility() {
      var hasRows = tbody && tbody.querySelectorAll("tr[data-size]").length > 0;
      if (emptyState) emptyState.style.display = hasRows ? "none" : "";
      if (tableWrap) tableWrap.style.display = hasRows ? "" : "none";
    }

    function refreshStatus() {
      if (!statusEl || !tbody) return;
      var rows = tbody.querySelectorAll("tr[data-size]");
      var total = rows.length;
      var missing = 0;
      rows.forEach(function (row) {
        var input = row.querySelector("[data-field=weight]");
        var empty = !input || String(input.value).replace(/^\s+|\s+$/g, "") === "";
        row.classList.toggle("is-missing-weight", empty);
        if (input) input.classList.toggle("is-empty", empty);
        if (empty) missing += 1;
      });
      statusEl.classList.remove("is-warn", "is-ok");
      if (total <= 0) {
        statusEl.textContent = "No sizes";
        statusEl.classList.add("is-ok");
      } else if (missing > 0) {
        statusEl.textContent = missing + " of " + total + " missing weight";
        statusEl.classList.add("is-warn");
      } else {
        statusEl.textContent = "All weights filled";
        statusEl.classList.add("is-ok");
      }
    }

    function reindexRows() {
      if (!tbody) return;
      var index = 0;
      tbody.querySelectorAll("tr[data-size]").forEach(function (row) {
        row.querySelectorAll("input[name^='weights[']").forEach(function (input) {
          var field = input.getAttribute("data-field");
          if (input.type === "hidden" && !field) {
            input.name = "weights[" + index + "][size]";
          } else if (field) {
            input.name = "weights[" + index + "][" + field + "]";
          }
        });
        index += 1;
      });
    }

    function ensureGroupRow(family) {
      var existing = tbody.querySelector('.wt-group-row[data-group="' + cssEscape(family.key) + '"]');
      if (existing) return existing;
      var tr = document.createElement("tr");
      tr.className = "wt-group-row";
      tr.setAttribute("data-group", family.key);
      tr.innerHTML = "<td colspan='5'></td>";
      tr.querySelector("td").textContent = (family.label || "").toUpperCase();

      var order = familyOrder();
      var insertBefore = null;
      var myIndex = order.indexOf(family.key);
      tbody.querySelectorAll(".wt-group-row").forEach(function (groupRow) {
        var otherIndex = order.indexOf(groupRow.getAttribute("data-group"));
        if (otherIndex > myIndex && !insertBefore) insertBefore = groupRow;
      });
      if (insertBefore) tbody.insertBefore(tr, insertBefore);
      else tbody.appendChild(tr);
      return tr;
    }

    function insertSizeRow(size, values) {
      values = values || {};
      var existing = tbody.querySelector('tr[data-size="' + cssEscape(size) + '"]');
      if (existing) {
        fillRowValues(existing, values);
        return existing;
      }

      var family = familyFor(size);
      var groupRow = ensureGroupRow(family);
      var tr = document.createElement("tr");
      tr.setAttribute("data-size", size);
      tr.setAttribute("data-family", family.key);
      tr.innerHTML =
        '<td><span class="wt-size-label"></span><input type="hidden" name="weights[0][size]" value=""></td>' +
        '<td class="is-num"><div class="wt-num-wrap"><input type="text" class="wt-num is-empty" name="weights[0][weight]" data-field="weight" inputmode="decimal" placeholder="Add"></div></td>' +
        '<td class="is-num"><div class="wt-num-wrap"><input type="text" class="wt-num" name="weights[0][width]" data-field="width" inputmode="decimal"></div></td>' +
        '<td class="is-num"><div class="wt-num-wrap"><input type="text" class="wt-num" name="weights[0][length]" data-field="length" inputmode="decimal"></div></td>' +
        '<td><button type="button" class="wt-remove" data-remove-size title="Remove size">&times;</button></td>';
      tr.querySelector(".wt-size-label").textContent = size;
      tr.querySelector('input[type="hidden"]').value = size;

      var next = groupRow.nextElementSibling;
      while (next && next.getAttribute("data-family") === family.key) {
        next = next.nextElementSibling;
      }
      if (next) tbody.insertBefore(tr, next);
      else tbody.appendChild(tr);
      fillRowValues(tr, values);
      syncEmptyVisibility();
      return tr;
    }

    function fillRowValues(row, values) {
      if (!values) return;
      var weight = row.querySelector("[data-field=weight]");
      var width = row.querySelector("[data-field=width]");
      var length = row.querySelector("[data-field=length]");
      if (weight && values.weight != null && values.weight !== "") weight.value = values.weight;
      if (width && values.width != null && values.width !== "") width.value = values.width;
      if (length && values.length != null && values.length !== "") length.value = values.length;
    }

    function removeSize(size) {
      var row = tbody.querySelector('tr[data-size="' + cssEscape(size) + '"]');
      if (!row) return;
      var familyKey = row.getAttribute("data-family");
      row.parentNode.removeChild(row);
      var checkbox = root.querySelector('[data-size-option="' + cssEscape(size) + '"]');
      if (checkbox) checkbox.checked = false;
      if (familyKey && !tbody.querySelector('tr[data-size][data-family="' + cssEscape(familyKey) + '"]')) {
        var group = tbody.querySelector('.wt-group-row[data-group="' + cssEscape(familyKey) + '"]');
        if (group) group.parentNode.removeChild(group);
      }
      reindexRows();
      syncEmptyVisibility();
      markDirty();
    }

    function toggleSizeFromCheckbox(checkbox) {
      var size = checkbox.getAttribute("data-size-option");
      if (!size) return;
      if (checkbox.checked) {
        insertSizeRow(size);
      } else {
        removeSize(size);
      }
      reindexRows();
      syncEmptyVisibility();
      markDirty();
    }

    function applyProductSizes(product) {
      Array(product.sizes || []).forEach(function (entry) {
        var checkbox = root.querySelector('[data-size-option="' + cssEscape(entry.size) + '"]');
        if (checkbox) checkbox.checked = true;
        insertSizeRow(entry.size, entry);
      });
      reindexRows();
      syncEmptyVisibility();
      markDirty();
    }

    function bindFillSearch(input, resultsEl) {
      if (!input || !resultsEl) return;
      input.addEventListener("input", function () {
        var key = input.id;
        clearTimeout(searchTimers[key]);
        var q = input.value.replace(/^\s+|\s+$/g, "");
        if (q.length < 2) {
          resultsEl.hidden = true;
          resultsEl.innerHTML = "";
          return;
        }
        searchTimers[key] = setTimeout(function () {
          var url = searchUrl +
            "?supplier_id=" + encodeURIComponent(supplierId) +
            "&q=" + encodeURIComponent(q);
          fetch(url, { headers: { Accept: "application/json" } }).
            then(function (response) { return response.json(); }).
            then(function (payload) {
              var results = (payload && payload.results) || [];
              if (!results.length) {
                resultsEl.innerHTML = '<div class="wt-muted" style="padding:0.75rem;">No products found.</div>';
                resultsEl.hidden = false;
                return;
              }
              resultsEl.innerHTML = results.map(function (item) {
                return '<button type="button" data-fill-item="' + item.item_code + '">' +
                  '<span class="wt-fill-code">' + item.item_code + "</span> " +
                  (item.product_name || "") +
                  '<span class="wt-fill-meta">' +
                  item.size_count + " sizes · " + item.weight_count + " with weight" +
                  "</span></button>";
              }).join("");
              resultsEl.hidden = false;
              resultsEl.querySelectorAll("[data-fill-item]").forEach(function (button) {
                button.addEventListener("click", function () {
                  var code = button.getAttribute("data-fill-item");
                  var match = results.find(function (item) { return item.item_code === code; });
                  if (!match) return;
                  applyProductSizes(match);
                  input.value = "";
                  resultsEl.hidden = true;
                  resultsEl.innerHTML = "";
                });
              });
            });
        }, 220);
      });
    }

    if (addTypeToggle && addTypePopover) {
      addTypeToggle.addEventListener("click", function (event) {
        event.preventDefault();
        addTypePopover.hidden = !addTypePopover.hidden;
      });
    }

    if (createTypeToggle && createTypeForm) {
      createTypeToggle.addEventListener("click", function (event) {
        event.preventDefault();
        createTypeForm.hidden = !createTypeForm.hidden;
        if (!createTypeForm.hidden && createTypeName) createTypeName.focus();
      });
    }

    if (createTypeSubmit && createTypeName && createTypeUrl) {
      createTypeSubmit.addEventListener("click", function (event) {
        event.preventDefault();
        var name = createTypeName.value.replace(/^\s+|\s+$/g, "");
        if (!name) return;
        var formEl = document.createElement("form");
        formEl.method = "post";
        formEl.action = createTypeUrl;
        var token = document.querySelector('meta[name="csrf-token"]');
        [["authenticity_token", token ? token.content : ""], ["supplier_id", supplierId], ["name", name]].forEach(function (pair) {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = pair[0];
          input.value = pair[1];
          formEl.appendChild(input);
        });
        document.body.appendChild(formEl);
        formEl.submit();
      });
    }

    var typeSearch = root.querySelector("#wt-type-search");
    if (typeSearch) {
      typeSearch.addEventListener("input", function () {
        var q = typeSearch.value.toLowerCase();
        root.querySelectorAll("#wt-type-picker li").forEach(function (li) {
          var text = li.textContent.toLowerCase();
          li.style.display = text.indexOf(q) === -1 ? "none" : "";
        });
      });
    }

    if (addSizesToggle && addSizesPopover) {
      addSizesToggle.addEventListener("click", function (event) {
        event.preventDefault();
        addSizesPopover.hidden = !addSizesPopover.hidden;
      });
    }

    if (pickManual && addSizesPopover) {
      pickManual.addEventListener("click", function (event) {
        event.preventDefault();
        addSizesPopover.hidden = false;
      });
    }

    document.addEventListener("click", function (event) {
      if (addSizesPopover && !addSizesPopover.hidden) {
        if (!addSizesPopover.contains(event.target) && !addSizesToggle.contains(event.target) &&
            !(pickManual && pickManual.contains(event.target))) {
          addSizesPopover.hidden = true;
        }
      }
      if (addTypePopover && !addTypePopover.hidden) {
        if (!addTypePopover.contains(event.target) && !addTypeToggle.contains(event.target)) {
          addTypePopover.hidden = true;
        }
      }
    });

    root.querySelectorAll("[data-select-family]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        var key = button.getAttribute("data-select-family");
        var block = root.querySelector('.wt-family-block[data-family="' + cssEscape(key) + '"]');
        if (!block) return;
        block.querySelectorAll("[data-size-option]").forEach(function (checkbox) {
          if (checkbox.checked) return;
          checkbox.checked = true;
          toggleSizeFromCheckbox(checkbox);
        });
      });
    });

    if (addSizesPopover) {
      addSizesPopover.addEventListener("change", function (event) {
        var checkbox = event.target.closest("[data-size-option]");
        if (!checkbox) return;
        toggleSizeFromCheckbox(checkbox);
      });
    }

    var addSizeButton = root.querySelector("#wt-add-size-button");
    var addSizeInput = root.querySelector("#wt-add-size-input");
    if (addSizeButton && addSizeInput) {
      addSizeButton.addEventListener("click", function (event) {
        event.preventDefault();
        var size = addSizeInput.value.replace(/^\s+|\s+$/g, "");
        if (!size) return;
        var checkbox = root.querySelector('[data-size-option="' + cssEscape(size) + '"]');
        if (checkbox) {
          checkbox.checked = true;
        } else if (addSizesPopover) {
          var family = familyFor(size);
          var block = root.querySelector('.wt-family-block[data-family="' + cssEscape(family.key) + '"]');
          if (!block) {
            block = document.createElement("div");
            block.className = "wt-family-block";
            block.setAttribute("data-family", family.key);
            block.innerHTML = '<div class="wt-family-head"><span></span></div><div class="wt-family-checks"></div>';
            block.querySelector("span").textContent = (family.label || "").toUpperCase();
            var custom = addSizesPopover.querySelector(".wt-custom-size");
            addSizesPopover.insertBefore(block, custom);
          }
          var label = document.createElement("label");
          label.innerHTML = '<input type="checkbox" data-size-option=""> ';
          label.querySelector("input").setAttribute("data-size-option", size);
          label.querySelector("input").checked = true;
          label.appendChild(document.createTextNode(size));
          block.querySelector(".wt-family-checks").appendChild(label);
        }
        insertSizeRow(size);
        reindexRows();
        addSizeInput.value = "";
        markDirty();
      });
    }

    if (tbody) {
      tbody.addEventListener("click", function (event) {
        var button = event.target.closest("[data-remove-size]");
        if (!button) return;
        event.preventDefault();
        var row = button.closest("tr[data-size]");
        if (!row) return;
        removeSize(row.getAttribute("data-size"));
      });
      tbody.addEventListener("input", function () {
        markDirty();
      });

      tbody.addEventListener("keydown", function (event) {
        var input = event.target.closest("input.wt-num, input[data-field]");
        if (!input) return;
        var key = event.key;
        if (key !== "ArrowDown" && key !== "ArrowUp" && key !== "ArrowLeft" && key !== "ArrowRight") return;

        var row = input.closest("tr[data-size]");
        if (!row) return;
        var field = input.getAttribute("data-field");
        if (!field) return;

        // Left/Right only leave the cell when the caret is at the end/start.
        if (key === "ArrowLeft" || key === "ArrowRight") {
          var start = input.selectionStart;
          var end = input.selectionEnd;
          var valueLength = String(input.value || "").length;
          if (start !== end) return;
          if (key === "ArrowLeft" && start > 0) return;
          if (key === "ArrowRight" && end < valueLength) return;
        }

        var rows = Array.prototype.slice.call(tbody.querySelectorAll("tr[data-size]"));
        var rowIndex = rows.indexOf(row);
        if (rowIndex < 0) return;
        var fields = ["weight", "width", "length"];
        var fieldIndex = fields.indexOf(field);
        if (fieldIndex < 0) return;

        var nextRowIndex = rowIndex;
        var nextFieldIndex = fieldIndex;
        if (key === "ArrowDown") nextRowIndex += 1;
        if (key === "ArrowUp") nextRowIndex -= 1;
        if (key === "ArrowRight") nextFieldIndex += 1;
        if (key === "ArrowLeft") nextFieldIndex -= 1;

        if (nextRowIndex < 0 || nextRowIndex >= rows.length) return;
        if (nextFieldIndex < 0 || nextFieldIndex >= fields.length) return;

        var nextInput = rows[nextRowIndex].querySelector('[data-field="' + fields[nextFieldIndex] + '"]');
        if (!nextInput) return;
        event.preventDefault();
        nextInput.focus();
        if (typeof nextInput.select === "function") nextInput.select();
      });
    }

    if (pasteOpen && pasteModal) {
      pasteOpen.addEventListener("click", function (event) {
        event.preventDefault();
        pasteModal.hidden = false;
        if (pasteArea) pasteArea.focus();
      });
    }
    if (pasteCancel && pasteModal) {
      pasteCancel.addEventListener("click", function (event) {
        event.preventDefault();
        pasteModal.hidden = true;
      });
    }
    if (pasteModal) {
      pasteModal.addEventListener("click", function (event) {
        if (event.target === pasteModal) pasteModal.hidden = true;
      });
    }
    if (pasteApply && pasteArea && tbody) {
      pasteApply.addEventListener("click", function (event) {
        event.preventDefault();
        var values = pasteArea.value.split(/\r?\n/).map(function (line) {
          return line.replace(/^\s+|\s+$/g, "");
        }).filter(function (line) { return line !== ""; });
        var rows = tbody.querySelectorAll("tr[data-size]");
        values.forEach(function (value, index) {
          if (!rows[index]) return;
          var input = rows[index].querySelector("[data-field=weight]");
          if (input) input.value = value;
        });
        pasteModal.hidden = true;
        markDirty();
      });
    }

    bindFillSearch(root.querySelector("#wt-fill-search"), root.querySelector("#wt-fill-results"));
    bindFillSearch(root.querySelector("#wt-empty-fill-search"), root.querySelector("#wt-empty-fill-results"));

    root.querySelectorAll("[data-segment] button").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        if (button.disabled) return;
        var value = button.getAttribute("data-value");
        setPhotoMode(value);
        if (value === "none") {
          markDirty();
        } else {
          removeImageInput.value = "";
          var frame = currentPhotoFrame();
          if (imageInput && (!imageInput.files || !imageInput.files[0]) &&
              (!frame || !frame.querySelector("img"))) {
            imageInput.click();
          }
          markDirty();
        }
      });
    });

    root.querySelectorAll("[data-replace-photo]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        if (imageInput) imageInput.click();
      });
    });

    if (imageInput) {
      imageInput.addEventListener("change", function () {
        if (!imageInput.files || !imageInput.files[0]) return;
        removeImageInput.value = "";
        var mode = photoModeInput ? photoModeInput.value : "supplier";
        if (mode === "none") mode = "supplier";
        setPhotoMode(mode);
        var url = URL.createObjectURL(imageInput.files[0]);
        var frame = currentPhotoFrame();
        if (frame) frame.innerHTML = '<img src="' + url + '" alt="">';
        var state = photoPanel && photoPanel.querySelector('.wt-photo-state[data-state="' + mode + '"]');
        if (state) {
          var replaceBtn = state.querySelector("[data-replace-photo]");
          var removeBtn = state.querySelector("[data-remove-photo]");
          if (replaceBtn) replaceBtn.textContent = "Replace";
          if (removeBtn) removeBtn.disabled = false;
        }
        markDirty();
      });
    }

    root.querySelectorAll("[data-remove-photo]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        removeImageInput.value = "1";
        if (imageInput) imageInput.value = "";
        var frame = currentPhotoFrame();
        if (frame) {
          frame.innerHTML = '<div class="wt-photo-placeholder">Upload a measuring photo</div>';
        }
        markDirty();
      });
    });

    if (discardButton) {
      discardButton.addEventListener("click", function (event) {
        event.preventDefault();
        window.location.reload();
      });
    }

    if (form && tbody) {
      form.addEventListener("submit", function () {
        reindexRows();
      });
    }

    setPhotoMode(photoPanel ? photoPanel.getAttribute("data-photo-mode") || "none" : "none");
    syncEmptyVisibility();
    refreshStatus();
    markClean();
  }

  return { init: init };
})();

document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("supplier_product_type_weights-c")) {
    App.SupplierProductTypeWeights.init();
  }
});
